import React from "react";
import Slide from 'react-reveal/Slide';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faFileAlt,
  faFileUpload,
  faDatabase,
  faShieldAlt,
  faBell,
} from "@fortawesome/free-solid-svg-icons";
import ServiceCard from "./ServiceCard";
import serviceData from "./serviceData"; // Import the service data
import Navbar from "./Navbar";

const Services = () => {
  return (
    <>
    
      <section className="plain-section" id="features">
        <div className="container-fluid">
          <div className="row" style={{ color: "hsl(180, 70%, 70%)" }}>
            {serviceData.map((service, index) => (
              <div className="feature-box col-lg-3 col-md-4" key={index}>
                <Slide up>
                <ServiceCard
                  alt={service.alt}
                  name={service.name}
                  imglink={service.imglink}
                  desc={service.desc}
                  descmore={service.descmore}
                />
                 </Slide>
              </div>
            ))}
          </div>
        </div>
      </section>
     
    </>
  );
};

export default Services;
